import { SHIFT } from 'shared/api';

export const getShiftTextRepresentation = (shift: SHIFT) => {
  switch (shift) {
    case SHIFT.MORNING:
      return 'Первая смена';
    case SHIFT.AFTERNOON:
      return 'Вторая смена';
    default:
      return shift;
  }
};
